const PodcastPageConfig: Record<string, any> = {
  subscription: null,
  ipfsGatewayUrl: ".ipfs.w3s.link"
};

export default PodcastPageConfig;
